// extracted by mini-css-extract-plugin
module.exports = {"documentsPopup":"documentsPopup__-jLzH","card":"card__X9lko","icon":"icon__03tGl","text":"text__LHFWf","button":"button__phAHM","review":"review__KAh+j","approve":"approve__KR8E+"};